import Vue from 'vue'

import Vuetify, {
    VApp,
    VRating,
    VBtnToggle,
    VMain,
    VFabTransition,
    VProgressCircular,
    VCard,
    VCardText,
    VCardTitle,
    VCardActions,
    VFileInput,
    VStepperContent,
    VStepper,
    VStepperStep,
    VStepperItems,
    VStepperHeader,
    VForm,
    VTextField,
    VTextarea,
    VBtn,
    VAppBar,
    VAppBarNavIcon,
    VContainer,
    VNavigationDrawer,
    VDivider,
    VList,
    VListItem,
    VListItemIcon,
    VListItemTitle,
    VOverlay,
    VListItemGroup,
    VIcon,
    VListItemAvatar,
    VImg,
    VListItemContent,
    VListItemSubtitle,
    VListItemAction,
    VToolbar,
    VToolbarTitle,
    VMenu,
    VSimpleTable,
    VPagination,
    VSelect,
    VSwitch,
    VSpacer,
    VProgressLinear,
    VFlex,
    VLayout,
    VCheckbox,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    VDialog,
    VAlert,
    VDatePicker,
    VRadio,
    VRadioGroup,
    VCombobox,
    VAutocomplete,
    VTabs,
    VTab,
    VTabItem,
    VTabsItems,
    VTabsSlider,
    VCol,
    VRow,
    VListGroup,
    VSnackbar,
    VExpandTransition,
    VScrollYTransition,
    VFooter,
    VCarousel,
    VCarouselItem,
    VHover,
    VChip,
    VFadeTransition,
    VDataIterator,
    VTooltip,
    VItem,
    VToolbarItems,
    VItemGroup,
    VAvatar,
    VParallax
} from "vuetify/lib"

import {ClickOutside} from 'vuetify/lib/directives'

Vue.use(Vuetify, {
    components: {
        VCarousel,
        VRating,
        VParallax,
        VScrollYTransition,
        VCarouselItem,
        VTooltip,
        VAvatar,
        VItem,
        VToolbarItems,
        VBtnToggle,
        VItemGroup,
        VApp,
        VMain,
        VFooter,
        VChip,
        VHover,
        VExpandTransition,
        VDataIterator,
        VFabTransition,
        VFadeTransition,
        VProgressCircular,
        VSpacer,
        VDatePicker,
        VOverlay,
        VDialog,
        VAlert,
        VListGroup,
        VCol,
        VRow,
        VTabs,
        VTab,
        VTabItem,
        VTabsItems,
        VTabsSlider,
        VRadio,
        VAutocomplete,
        VCombobox,
        VRadioGroup,
        VExpansionPanels,
        VExpansionPanel,
        VExpansionPanelHeader,
        VExpansionPanelContent,
        VLayout,
        VFlex,
        VCheckbox,
        VCard,
        VCardText,
        VCardTitle,
        VCardActions,
        VFileInput,
        VStepperContent,
        VStepper,
        VStepperStep,
        VStepperItems,
        VStepperHeader,
        VForm,
        VTextField,
        VTextarea,
        VBtn,
        VAppBar,
        VAppBarNavIcon,
        VContainer,
        VNavigationDrawer,
        VDivider,
        VList,
        VListItem,
        VListItemIcon,
        VListItemTitle,
        VListItemGroup,
        VIcon,
        VListItemAvatar,
        VImg,
        VListItemContent,
        VListItemSubtitle,
        VListItemAction,
        VToolbar,
        VToolbarTitle,
        VMenu,
        VSimpleTable,
        VPagination,
        VSelect,
        VSwitch,
        VProgressLinear,
        VSnackbar
    },
    directives: {ClickOutside}
})

export default new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        dark: false,
    },
    themes: {
        light: {
            primary: "#ed4b3f",
            secondary: "#b0bec5",
            accent: "#8c9eff",
            error: "#b71c1c",
        },
    },
})
